import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        item: {
            avatar: '',
            name: '',
            hours: '',
            goods: '',
            title: '',
            body: '',
            picList: [],
            place: '',
        },
        token: '',
        userInfo: {},
        place: {
            lng: '',
            lat: '',
            formattedAddress: ''
        },
        queryParams: {},
        shopUserInfo: {}
    },
    mutations: {
        setShopUserInfo(state, item) {
            state.shopUserInfo = item
        },
        setQueryParams(state, item) {
            state.queryParams = item
        },
        itemChange(state, item) {
            state.item = item
        },
        setToken(state, token) {
            state.token = token
            return state
        },
        setUserInfo(state, userInfo) {
            console.log(userInfo, 'userInfo')
            state.userInfo = userInfo
        },
        placeChange(state, lng) {
            state.place = lng
        }
    },
    actions: {},
    modules: {}
});